import React from 'react';
import styled, { css } from 'styled-components';
import shortId from 'shortid';
import { theme } from '../../styled';
import ErrorMessage from '../ErrorMessage';
import { Tick } from '../Icons';
export const CheckboxWrapper = styled.div `
  display: flex;
  color: ${(props) => props.theme.navyBlue};
  margin-top: 10px;

  &:first-child {
    margin-top: 0;
  }

  input {
    position: absolute;
    left: -9999px;
  }

  label {
    position: relative;
    margin-bottom: 0;
    padding-left: ${(props) => (props.withIco ? '27px' : '5px')};
    color: ${(props) => props.theme.navyBlue};
    font-size: ${(props) => props.theme.fontSmall};
    line-height: 21px;

    cursor: pointer;
  }

  ${(props) => props.isEnterprise
    ? css `
          .tickBox {
            position: absolute;
            left: 0;
            top: 0.22em;
            width: 1.15em;
            height: 1.15em;
            border: 2px solid #ccc;
            background: #fff;
            border-radius: 4px;
            box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
          }

          .tickIcon {
            position: absolute;
            top: -2px;
            left: 1px;
            transition: all 0.2s;
            opacity: 0;
            transform: scale(0);
          }
        `
    : css `
          .tickBox {
            position: absolute;
            left: 0;
            top: 1px;
            width: 18px;
            height: 18px;
            border: 1px solid ${props.invalid ? props.theme.red : '#000'};
            box-sizing: content-box;
          }

          .tickIcon {
            position: absolute;
            top: 4px;
            left: 3px;
            opacity: 0;
            transform: scale(0);
          }
          input:checked + label .tickBox {
            background: #000;
          }
        `}

  input:checked + label .tickIcon {
    opacity: 1;
    transform: scale(1);
  }

  input:disabled + label {
    cursor: default;

    .tickBox {
      opacity: 0.5;
    }
  }
`;
const TextWrapper = styled.span `
  ${(props) => props.required &&
    css `
      &::before {
        content: '* ';
        color: ${theme.red};
      }
    `};
`;
const StandardCheckboxWithLabel = ({ checkboxProps, className = '', labelProps, standardLabelProps, errorProps, required, error, label, withIco, isEnterprise, }) => {
    const id = shortId.generate();
    return (React.createElement(CheckboxWrapper, { className: `Checkbox standard-checkbox ${className}`, invalid: error, withIco: withIco, isEnterprise: isEnterprise },
        React.createElement("input", Object.assign({ type: "checkbox", id: id }, checkboxProps)),
        React.createElement("label", Object.assign({ htmlFor: id }, labelProps),
            withIco && !isEnterprise && (React.createElement("div", { className: "tickBox" },
                React.createElement(Tick, { color: "#fff", className: "tickIcon", width: 12, height: 10 }))),
            withIco && isEnterprise && (React.createElement("div", { className: "tickBox" },
                React.createElement(Tick, { color: "#1c92dd", className: "tickIcon" }))),
            React.createElement(TextWrapper, Object.assign({ className: "standard-checkbox-label", required: required }, standardLabelProps), label),
            error && React.createElement(ErrorMessage, Object.assign({ message: error }, errorProps)))));
};
StandardCheckboxWithLabel.defaultProps = {
    error: null,
    required: false,
    withIco: true,
};
export default StandardCheckboxWithLabel;
